import { Component, EventEmitter, OnInit, AfterViewInit, ViewChild, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { custom } from 'devextreme/ui/dialog';
import * as moment from 'moment';
import { DxDataGridComponent } from "devextreme-angular";
import { forkJoin } from "rxjs";
import { locale, loadMessages } from 'devextreme/localization';
import noMessages from "src/assets/devextreme/messages/no.json";
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons';
import { EditTransportComponent } from './edit-transport/edit-transport.component';
import CustomStore from 'devextreme/data/custom_store';
import { TimeService } from '../../../_api/services/time.service';
import { ProjectService } from '../../../../project/_api/services/project.service';
import { LanguageService } from '../../../../../shared/services/language.service';
import { UserService } from '../../../../../shared/services/user.service';
import { AmsNotifierService } from '../../../../../shared/services/ams-notifier.service';
import { PortalTemplateService } from "src/app/modules/admin/_api/services/portal-template.service";
import { PortalTemplateTimetypeSelectorComponent } from "src/app/shared/components/portal-template-timetype-selector/portal-template-timetype-selector.component";
import { GridToTimeSalaryConverter } from "./grid-to-time-salary-converter.service";
import { TimeSalaryToGridConverter } from "./time-salary-to-grid-converter.service";
import { AdminRoleService } from 'src/app/_api/services/role.service';
import { ProjectPortalEmployeeSelectorComponent } from "src/app/shared/components/project-portal-employee-selector/project-portal-employee-selector.component";
import { PortalTypeService } from '../../../../../shared/services/portal-type.service';

@Component({
  selector: 'app-timesalaryapproval-detail-time',
  templateUrl: './timesalaryapproval-detail-time.component.html',
  styleUrls: ['./timesalaryapproval-detail-time.component.css']
})
export class TimesalaryapprovalDetailTimeComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('datagriddx', {static:false}) dataGrid: DxDataGridComponent;
  @ViewChild('editTransport', {static:false}) editTransport: EditTransportComponent;
  @ViewChild('portalTemplateSelector', { static: false }) portalTemplateSelector: PortalTemplateTimetypeSelectorComponent;
  @ViewChild('projectPortalEmployeeSelector', { static: false }) projectPortalEmployeeSelector: ProjectPortalEmployeeSelectorComponent;

  private readonly overtimeCheckKey = "direct-desktop-project-portal-approval-overtime-check";
  private readonly supervisorCheckKey = "direct-desktop-project-portal-approval-supervisor-check";

  @Input() portalType: string;
  @Input() selectedProjectId?: number;
  @Input()
  get projectReadWriteAll(): boolean { return this._projectReadWriteAll; }
  set projectReadWriteAll(projectReadWriteAll: boolean) {
    this._projectReadWriteAll = projectReadWriteAll;
  }  
  @Input() allowEditUnconfirmed = true;
  @Input() allowEditConfirmed = true;
  @Input() allowEditApproved = false;
  @Input() selectedEmployeeId: number;
  @Input() showEmployeeColumn: boolean = false;
  @Input() showTransportColumn: boolean = false;
  @Input() showUnconfirmed: boolean = true;
  @Input() timetypes: any;
  @Input() projectActivities: any;
  @Input() employees: any;
  @Input() isAdmin = false;
  @Input() showTitle = false;
  @Input() newStatusId: number = 3;//Eirik 02.12.19 task 154 - status when inserting time posts
  @Input() copyTimeStatusId: number = 200; 
  @Input() newCategoryId: number = 6;//Eirik 02.12.19 task 154 - category when inserting time posts
  @Input() categoriesToApprove: number[] = [6];//Eirik 02.12.19 task 154 - category when inserting time posts
  @Input() visibleIndexProject: number = 7;//Eirik 20.03.20 task 264 - this is shown as index 2 in projectportal
  @Input() disableWrongSupervisor = false;//Eirik 12.05.21 v2.0.32.11 task 1200 - only check SupervisorId from EmployeePortal
  @Input() showAllSwitchVisible = false;
  @Input() showOvertimeSwitch: any;
  @Input() minusGridHeight: number = 625;
  @Input()
  get employeeHasProjectPermissions(): boolean { return this._employeeHasProjectPermissions; }
  set employeeHasProjectPermissions(employeeHasProjectPermissions: boolean) {
    this._employeeHasProjectPermissions = employeeHasProjectPermissions;
  }  
  @Input() showSupervisorApprovalSwitch: any;

  myApprovalLevelStatuses: number[] = [];

  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  @Output() refresh = new EventEmitter<boolean>();//false if not clearing datagrid selections
  @Output() cellPrepared = new EventEmitter<any>();
  @Output() editingStart = new EventEmitter<any>();
  @Output() rowInserting = new EventEmitter<any>();
  @Output() rowUpdating = new EventEmitter<any>();
  @Output() selectedCarrierIdTransportRow = new EventEmitter<number>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() showAllSwitchClicked = new EventEmitter<any>();
  @Output() overtimeCheckActive = new EventEmitter<boolean>();
  @Output() approvalLevelStatuses = new EventEmitter<number[]>();
  @Output() allStatuses = new EventEmitter<any[]>();
  @Output() supervisorApprovalSwitchActive = new EventEmitter<boolean>();
  @Output() supervisorApprovalEmployeeChanged = new EventEmitter<any>();

  dataSource: any;
  customStoreDataSource: any;
  columns: any;
  projectsDataSource: DataSource;
  projectActivitiesByProjectType: any;
  selectedPortalTemplate: number = null;
  timeTypeColumns = [];
  approvalFunction: number;

  supervisorEmployees = [];

  editMode = "row";
  popupVisible = false;
  popupEditTransportVisible = true;
  popupQuickEntryVisible = false;
  customerPopupDataSource: DataSource;
  projectsPopupDataSource: DataSource;
  selectedProjectIdPopup: number = -1;
  selectedCustomerIdPopup: number = -1;
  selectedProjectItemPopup: any;
  cloneData: any;
  labels = {
    Unconfirmed: '',
    Confirmed: '',
    Approved: '',
    ReadySalary: '',
    TransferredSalary: ''
  };
  searchParameters = {
    EmployeeIds: [],
    FromDate: "",
    ToDate: "",
    StatusIds: [],
    CategoryIds: [],
    CategoryStatusCombos: [],
    DepartmentIds: [],
    IsSupervisor: false,
    SelectedSupervisorId: -1,
    ProjectIds: [],
    hasReadAllPermission: false,
  }
  //Eirik 18.05.20 task 564 - the display of the projectcolumn is determined on the server, but there might be cases where we need to prevent showing this column no matter what
  @Input() preventShowingProjectActivityColumn: boolean = false;
  showProjectActivityColumn: boolean = false;
  enableProjectActivityColumn: boolean = false;
  readonlyProjectActivity: boolean = false;
  colorCodeUnconfirmed = "#EE745D";
  colorCodeApproved = "#8CC588"
  colorUnconfirmed = this.colorCodeUnconfirmed;
  colorConfirmed = "";
  colorApproved = this.colorCodeApproved;
  headerFilterData = [];
  projectIdsDataSource: any[];//when searching, only search for these projects
  validateHoursMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.23.Hours");
  validateMinutesMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.59.Minutes");
  placeholderProjectSelectSearch = this.languageService.LNG("Label.MinThreeCharacters");
  title = "";
  titleEditTransport: string;
  transport: any;  
  faTruckMoving = faTruckMoving;
  switchShowAll: boolean = true;
  switchOvertimeCheck: boolean = localStorage.getItem(this.overtimeCheckKey) === "true";
  overtimeSwitchVisible: boolean;
  statuses = [];
  isNewRow: boolean = false;
  gridStyle: string;
  switchSupervisorCheck: boolean = localStorage.getItem(this.supervisorCheckKey) === "true";
  employeeSelectorVisible: boolean = false;
  isDateChangedOutOfSearchPeriod = false;

  isApproving = false;
  isResetting = false;

  lastUpdateDate: Date = null;
  editRowKey: number = null;

  private _projectReadWriteAll: boolean = false;
  private _employeeHasProjectPermissions: boolean = false;

  constructor(
    private timeService: TimeService,
    private projectService: ProjectService,
    public languageService: LanguageService,
    private userService: UserService,
    private amsNotifierService: AmsNotifierService,
    private portalTemplatesService: PortalTemplateService,
    private gridToTimeSalaryConverter: GridToTimeSalaryConverter,
    private timeSalaryToGridConverter: TimeSalaryToGridConverter,
    private roleService: AdminRoleService,
    private portalTypeService: PortalTypeService) {
      loadMessages(noMessages);
      locale('no');
      this.setProjectValue = this.setProjectValue.bind(this);
    }

  ngOnInit() {
    this.loadStatuses();
    this.popupEditTransportVisible = false;
    this.labels.Unconfirmed = this.languageService.LNG("Label.Unconfirmed");
    this.labels.Confirmed = this.languageService.LNG("Label.Confirmed");
    this.labels.Approved = this.languageService.LNG("Label.Is.Approved");
    this.labels.ReadySalary = this.languageService.LNG("Label.Ready.For.Salary");
    this.labels.TransferredSalary = this.languageService.LNG("Label.Transferred.Salary");
    this.title = this.languageService.LNG("Label.Hours");

    this.setLookUps();
    if (this.userService.account.IsAdmin) {
      this.colorUnconfirmed = this.colorCodeUnconfirmed;
      this.colorConfirmed = "";
      this.colorApproved = this.colorCodeApproved;
    }
    else {
      this.colorUnconfirmed = "";
      this.colorConfirmed = this.colorCodeApproved;
      this.colorApproved = this.colorCodeApproved;
    }
    
    if (this.showAllSwitchVisible) { this.switchShowAll = false }

    if (this.switchSupervisorCheck) { this.employeeSelectorVisible = true; }
  }

  ngAfterViewInit() {
    this.approvalFunction = this.portalTypeService.isProjectPortal(this.portalType) ? 2 : 1;
    this.gridStyle = `padding: 20px; position: relative; height: calc(100vh - ${this.minusGridHeight}px); min-height: 200px;`;
    this.setColumns();
    this.loadRoleApprovalLevels();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.minusGridHeight) {
      this.gridStyle = `padding: 20px; position: relative; height: calc(100vh - ${changes.minusGridHeight.currentValue}px); min-height: 200px;`;
    }
  }

  private async setColumns() {
    if (this.selectedPortalTemplate === null) {
      this.selectedPortalTemplate = this.portalTemplateSelector.getCurrentPortalTemplate();
    }

    if (this.selectedPortalTemplate === null) { return; }

    let columnSettings = null;

    if (this.portalTypeService.isProjectPortal(this.portalType)) {
      columnSettings = await this.portalTemplatesService.getProjectPortalGridColumn(this.selectedPortalTemplate).toPromise();
    } else {
      columnSettings = await this.portalTemplatesService.getEmployeePortalGridColumn(this.selectedPortalTemplate).toPromise();
    }

    this.timeTypeColumns = columnSettings.TimeTypeColumnDtos;

    this.columns = [
      { dataField: "StatusId", caption: " ", cellTemplate: "cellTemplateStatus", allowEditing: false, calculateSortValue: "StatusId", calculateGroupValue: "StatusDescription", headerFilter: { dataSource: this.headerFilterData }, width: 50, fixed: "left" },
      { dataField: "Date", caption: this.languageService.LNG("Label.Date"), groupCellTemplate: "dateGroupTemplate", visible: columnSettings.ShowDate, dataType: "date", format: { day: '2-digit', month: '2-digit', year: '2-digit' }, width: 100, fixed: "left" },
      { dataField: "EmployeeNumberAndName", caption: this.languageService.LNG("Label.Employee"), editCellTemplate: "employeeEditTemplate", setCellValue: this.setEmployeeValue, visible: columnSettings.ShowEmployee, width: 200, fixed: "left", alignment: "left" },
      { dataField: "WeekNo", caption: this.languageService.LNG("Label.Week"), allowEditing: false, alignment: "right", visible: columnSettings.ShowWeekNumber, width: 60, fixed: "left" },
      { dataField: "Project", caption: this.languageService.LNG("Label.Project"), visibleIndex: "visibleIndexProject", editCellTemplate: "projectEditTemplate", setCellValue: this.setProjectValue, visible: columnSettings.ShowProject, width: 450, fixed: "left", alignment: "left" },
      { dataField: "FromProjectNumber", caption: this.languageService.LNG("Label.From"), cellTemplate: "cellTemplateFromProject", editCellTemplate: "fromProjectEditTemplate", setCellValue: this.setFromProjectValue, visible: columnSettings.ShowFromProject, width: 100, fixed: "left", alignment: "left" },
      { dataField: "ToProjectNumber", caption: this.languageService.LNG("Label.To"), cellTemplate: "cellTemplateToProject", editCellTemplate: "toProjectEditTemplate", setCellValue: this.setToProjectValue, visible: columnSettings.ShowToProject, width: 100, fixed: "left", alignment: "left" },
      { dataField: "Activity", caption: this.languageService.LNG("Label.Project.Activity"), editCellTemplate: "projectActivityEditTemplate", setCellValue: this.setProjectActivityValue, visible: columnSettings.ShowActivity, fixed: "left", width: 200 },
      { dataField: "Department", caption: this.languageService.LNG("Label.Department"), visible: columnSettings.ShowDepartment, allowEditing: false, fixed: "left" },
      { dataField: "Supervisor", caption: this.languageService.LNG("Label.Supervisor"), visible: columnSettings.ShowSupervisor, allowEditing: false, fixed: "left" },
      { dataField: "Customer", caption: this.languageService.LNG("Label.Customer"), visible: columnSettings.ShowCustomer, allowEditing: false, fixed: "left" },
      { caption: this.languageService.LNG("Label.Type"), cellTemplate: "typeCellTemplate", visible: columnSettings.ShowType, fixed: "left", allowEditing: false }
    ];

    if(columnSettings.ShowComment && columnSettings.ShowCommentColumnInFront) {
      this.columns.push({ dataField: "Comment", caption: this.languageService.LNG("Label.Comment"), fixed: "left", width: 100 });
    }

    this.timeTypeColumns.forEach((timeTypeColumnDto: any) => {
      this.columns.push({ dataField: `TimeType_${timeTypeColumnDto.TimeTypeId}`, caption: timeTypeColumnDto.Code, alignment: "right", cellTemplate: "timeCellTemplate", editCellTemplate: "timeEditTemplate", allowSorting: false, allowFiltering: false, width: 110 });
    });

    if(columnSettings.ShowComment && !columnSettings.ShowCommentColumnInFront) {
      this.columns.push({ dataField: "Comment", caption: this.languageService.LNG("Label.Comment") });
    }
  }

  async onPortalTemplateValueChanged(id: number) {
    this.selectedPortalTemplate = id;
    await this.setColumns();
  }

  async onProjectPortalEmployeeValueChanged(e: any) {
    this.supervisorApprovalEmployeeChanged.emit(e);
  }

  //get project and its child projects
  async loadListRecords(employeeIds, fromSearchDate, toSearchDate, selectedStatusIds, selectedCategoryIds, selectedDepartmentIds, isSupervisor, selectedSupervisorId?: number) {
    if (this.selectedPortalTemplate === null) { this.onLoading(false); return []; }

    this.searchParameters.EmployeeIds = employeeIds;
    this.searchParameters.FromDate = fromSearchDate;
    this.searchParameters.ToDate = toSearchDate;
    this.searchParameters.StatusIds = selectedStatusIds;
    this.searchParameters.CategoryIds = selectedCategoryIds;
    this.searchParameters.DepartmentIds = selectedDepartmentIds;
    this.searchParameters.IsSupervisor = isSupervisor;

    if (!this.selectedEmployeeId) {
      selectedSupervisorId = selectedSupervisorId !== null && selectedSupervisorId !== undefined ? selectedSupervisorId : -1
      this.searchParameters.SelectedSupervisorId = selectedSupervisorId;
    }

    this.onLoading(true);
    this.clearDataGridSelections();

    const result = this.selectedProjectId === null
      ? await this.timeService.getTimeSalariesWithinPeriod(employeeIds, fromSearchDate, toSearchDate, selectedStatusIds, selectedCategoryIds, selectedDepartmentIds, isSupervisor, selectedSupervisorId, this.selectedPortalTemplate).toPromise()
      : await this.timeService.getTimeSalariesByProjectWithinPeriod(employeeIds, fromSearchDate, toSearchDate, selectedStatusIds, selectedCategoryIds, selectedDepartmentIds, isSupervisor, selectedSupervisorId, this.selectedProjectId, this.selectedPortalTemplate).toPromise();

    this.timeSalaryToGridConverter.convert(result.Data.EmployeeTimeSalaries);
    this.dataSource = result.Data.EmployeeTimeSalaries;
    this.showProjectActivityColumn = !this.preventShowingProjectActivityColumn ? result.Data.UseProjectActivity : false;

    this.onLoading(false);
  }

  clearDataGridSelections() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearSorting();
  }

  selectAll() {
    this.dataGrid.instance.selectAll();
  }

  deselectAll() {
    this.dataGrid.instance.deselectAll();
  }

  //show grouped date as "dddd DD.MM.YYYY". the date from dataField has format DD.MM.YYYY
  groupTemplate(data) {
    let date = data.value;
    let dt = moment(date);
    var nb = moment(dt).locale('nb');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    return dateDDMMYYYY;
  }

  //get project and its child projects
  async loadListRecordsCategoryStatusCombos(
    employeeIds,
    fromSearchDate,
    toSearchDate,
    categoryStatusCombos,
    selectedDepartmentIds,
    isSupervisor,
    selectedSupervisorId?: number,
    projectIds?: number[],
    refreshSearchCriterias: boolean = true,
    showLoader: boolean = true,
    hasReadAllPermission?: boolean,
    supervisorEmployees: any[] = [],
    supervisorEmployeeSelected: number = null): Promise<any> {

    if (this.selectedPortalTemplate === null) { this.onLoading(false); return []; }

    if (this.lastUpdateDate === null) {
      this.dataSource = null;
    }

    this.searchParameters.EmployeeIds = employeeIds;
    this.searchParameters.FromDate = fromSearchDate;
    this.searchParameters.ToDate = toSearchDate;
    this.searchParameters.CategoryStatusCombos = categoryStatusCombos;
    this.searchParameters.DepartmentIds = selectedDepartmentIds;
    this.searchParameters.IsSupervisor = isSupervisor;
    this.searchParameters.hasReadAllPermission = hasReadAllPermission;

    if (!this.selectedEmployeeId) {
      selectedSupervisorId = selectedSupervisorId !== null && selectedSupervisorId !== undefined ? selectedSupervisorId : -1;
      this.searchParameters.SelectedSupervisorId = selectedSupervisorId;
    }

    this.searchParameters.ProjectIds = projectIds != null ? projectIds : [];
    
    if (showLoader) { this.onLoading(true); }
    if (refreshSearchCriterias) { this.clearDataGridSelections(); }
    const result = this.selectedProjectId === null || this.selectedProjectId === undefined
      ? await this.timeService.getTimeSalariesByCategoryStatusPairsWithinPeriod(employeeIds, fromSearchDate, toSearchDate, categoryStatusCombos, selectedDepartmentIds, this.searchParameters.ProjectIds, isSupervisor, selectedSupervisorId, this.selectedPortalTemplate, this.switchShowAll, hasReadAllPermission, this.lastUpdateDate).toPromise()
      : await this.timeService.getTimeSalariesByProjectWithChildrenAndCategoryStatusPairsWithinPeriod(employeeIds, fromSearchDate, toSearchDate, categoryStatusCombos, selectedDepartmentIds, this.searchParameters.ProjectIds, isSupervisor, selectedSupervisorId, this.selectedProjectId, this.selectedPortalTemplate, this.switchShowAll, this.lastUpdateDate).toPromise();

    this.timeSalaryToGridConverter.convert(result.Data.EmployeeTimeSalaries);
    this.updateDataSource(result.Data.EmployeeTimeSalaries, this.lastUpdateDate !== null);
    this.showProjectActivityColumn = !this.preventShowingProjectActivityColumn ? result.Data.UseProjectActivity : false;

    if (this.projectPortalEmployeeSelector) {
      this.supervisorEmployees = supervisorEmployees;
      this.projectPortalEmployeeSelector.employees = supervisorEmployees;
      this.projectPortalEmployeeSelector.selectedEmployee = supervisorEmployeeSelected;
    }

    if (showLoader) { this.onLoading(false); }

    this.isApproving = this.isResetting = false;
    this.lastUpdateDate = null;
  }

  private updateDataSource(timeSalaries: any[], hasOnlyNewlyUpdatedRecords: boolean) {
    if (!hasOnlyNewlyUpdatedRecords) {
      this.dataSource = timeSalaries;
      return;
    }

    const dataSource = this.dataSource;

    for (let i = 0; i < timeSalaries.length; i++) {
      const timeSalary = timeSalaries[i];
      let currentItemIndex = -1; 

      let indexFromTimeId = dataSource.findIndex((x: any) => x.TimeId === timeSalary.TimeId); 
      let timeFromDataSource = dataSource[indexFromTimeId];  
      let isCopyTimeStatusEdit = false
      
      if(timeFromDataSource !== undefined) 
        isCopyTimeStatusEdit = timeFromDataSource.StatusId == this.copyTimeStatusId && timeSalary.StatusId !== this.copyTimeStatusId; 

      currentItemIndex = dataSource.findIndex((x: any) => x.CarrierId === timeSalary.CarrierId && x.ProjectId === timeSalary.ProjectId &&
        x.EmployeeId === timeSalary.EmployeeId && x.Date === timeSalary.Date && x.CategoryId === timeSalary.CategoryId &&
        x.StatusId === timeSalary.StatusId);

      if (currentItemIndex !== -1) {
        dataSource[currentItemIndex] = timeSalary;
        continue;
      } else if (indexFromTimeId !== -1) {
        dataSource[indexFromTimeId] = timeSalary;
        continue;
      }

      dataSource.unshift(timeSalary);
    }

    function sortTimeSalaries(data: any[]) {
      return data.sort((a: any, b: any) => {
        return Date.parse(a.Date) - Date.parse(b.Date) !== -1 || a.ProjectNumber.localeCompare(b.ProjectNumber) || a.Activity.localeCompare(b.Activity);
      });
    }

    this.dataSource = sortTimeSalaries(dataSource);
  }

  //get project and its child projects
  async loadListRecordsAvailableToApprove(
    employeeIds,
    fromSearchDate,
    toSearchDate,
    categoryStatusCombos,
    selectedDepartmentIds,
    isSupervisor,
    selectedSupervisorId?: number,
    projectIds?: number[],
    refreshSearchCriterias: boolean = true,
    showLoader: boolean = true): Promise<any> {

    if (this.selectedPortalTemplate === null) { this.onLoading(false); return []; }

    this.searchParameters.EmployeeIds = employeeIds;
    this.searchParameters.FromDate = fromSearchDate;
    this.searchParameters.ToDate = toSearchDate;
    this.searchParameters.DepartmentIds = selectedDepartmentIds;
    this.searchParameters.IsSupervisor = isSupervisor;

    if (!this.selectedEmployeeId) {
      selectedSupervisorId = selectedSupervisorId !== null && selectedSupervisorId !== undefined ? selectedSupervisorId : -1;
      this.searchParameters.SelectedSupervisorId = selectedSupervisorId;
    }
    this.searchParameters.ProjectIds = projectIds != null ? projectIds : [];

    if (showLoader) { this.onLoading(true); }
    if (refreshSearchCriterias) { this.clearDataGridSelections(); }
    
    const result = this.selectedProjectId === null || this.selectedProjectId === undefined
      ? await this.timeService.getTimeSalariesByCategoryStatusPairsWithinPeriod(employeeIds, fromSearchDate, toSearchDate, categoryStatusCombos, selectedDepartmentIds, this.searchParameters.ProjectIds, isSupervisor, selectedSupervisorId, this.selectedPortalTemplate).toPromise()
      : await this.timeService.getTimeSalariesByProjectWithChildrenAndCategoryStatusPairsWithinPeriod(employeeIds, fromSearchDate, toSearchDate, categoryStatusCombos, selectedDepartmentIds, this.searchParameters.ProjectIds, isSupervisor, selectedSupervisorId, this.selectedProjectId, this.selectedPortalTemplate).toPromise();

    this.timeSalaryToGridConverter.convert(result.Data.EmployeeTimeSalaries);
    this.dataSource = result.Data.EmployeeTimeSalaries;
    this.showProjectActivityColumn = !this.preventShowingProjectActivityColumn ? result.Data.UseProjectActivity : false;

    if (showLoader) { this.onLoading(false); }
  }

  //get project and its child projects
  loadListRecordsCategoryStatusCombosCustomStore(employeeIds, fromSearchDate, toSearchDate, categoryStatusCombos, selectedDepartmentIds, isSupervisor, selectedSupervisorId?: number, projectIds?: number[], refreshSearchCriterias: boolean = true, showLoader: boolean = true) {

    this.searchParameters.EmployeeIds = employeeIds;
    this.searchParameters.FromDate = fromSearchDate;
    this.searchParameters.ToDate = toSearchDate;
    this.searchParameters.CategoryStatusCombos = categoryStatusCombos;
    this.searchParameters.DepartmentIds = selectedDepartmentIds;
    this.searchParameters.IsSupervisor = isSupervisor;
    if (!this.selectedEmployeeId) {
      selectedSupervisorId = selectedSupervisorId !== null && selectedSupervisorId !== undefined ? selectedSupervisorId : -1
      this.searchParameters.SelectedSupervisorId = selectedSupervisorId;
    }
    this.searchParameters.ProjectIds = projectIds != null ? projectIds : [];
    if (showLoader) {
      this.onLoading(true);
    }

    if (!this.customStoreDataSource) {
      this.createCustomStore(refreshSearchCriterias);
    }
    else {
      this.dataGrid.instance.refresh();
    }
  }

  startInsert = false;
  createCustomStore(refreshSearchCriterias) {
    this.customStoreDataSource = new CustomStore({
      load: (loadOptions: any) => {

            return this.loadRowsCustomerStore(refreshSearchCriterias);
        },
        insert: (values) => {

          this.startInsert = true;
          return this.insertRow(values);
        }
    });
  }

  async loadRowsCustomerStore(refreshSearchCriterias: boolean) : Promise<any> {
    if (this.selectedPortalTemplate === null) { this.onLoading(false); return []; }
    if (refreshSearchCriterias) { this.clearDataGridSelections(); }
    
    const result = this.selectedProjectId === null || this.selectedProjectId === undefined
      ? await this.timeService.getTimeSalariesByCategoryStatusPairsWithinPeriod(this.searchParameters.EmployeeIds, this.searchParameters.FromDate, this.searchParameters.ToDate, this.searchParameters.CategoryStatusCombos, this.searchParameters.DepartmentIds, this.searchParameters.ProjectIds, this.searchParameters.IsSupervisor, this.searchParameters.SelectedSupervisorId, this.selectedPortalTemplate).toPromise()
      : await this.timeService.getTimeSalariesByProjectWithChildrenAndCategoryStatusPairsWithinPeriod(this.searchParameters.EmployeeIds, this.searchParameters.FromDate, this.searchParameters.ToDate, this.searchParameters.CategoryStatusCombos, this.searchParameters.DepartmentIds, this.searchParameters.ProjectIds, this.searchParameters.IsSupervisor, this.searchParameters.SelectedSupervisorId, this.selectedProjectId, this.selectedPortalTemplate).toPromise();

    this.timeSalaryToGridConverter.convert(result.Data.EmployeeTimeSalaries);
    this.dataSource = result.Data.EmployeeTimeSalaries;
    this.showProjectActivityColumn = !this.preventShowingProjectActivityColumn ? result.Data.UseProjectActivity : false;

    this.onLoading(false);

    return result.Data.EmployeeTimeSalaries;
  }

  rowsToInsert = [];
  insertRow(values): Promise<boolean> {
    return new Promise(resolve => {
      this.rowsToInsert.push(values);

        setTimeout(() => {

          if (this.startInsert) {
            this.startInsert = false;
            let timesalaries = [];
            let isValidInsertRows = true;
            this.rowsToInsert.forEach(insertRow => {
              if (this.gridToTimeSalaryConverter.isValid(insertRow)) {
                let employeeId = insertRow.EmployeeId ? insertRow.EmployeeId : this.selectedEmployeeId;
                let seconds = this.getSeconds((insertRow.TotSecondsToHH !== null && insertRow.TotSecondsToHH !== undefined) ? (insertRow.TotSecondsToHH.length > 0 ? insertRow.TotSecondsToHH : 0) : insertRow.TotSecondsToHH,
                                              (insertRow.TotSecondsTomm !== null && insertRow.TotSecondsTomm !== undefined) ? (insertRow.TotSecondsTomm.length > 0 ? insertRow.TotSecondsTomm : 0) : insertRow.TotSecondsTomm);

                let timesalary = {
                  TimeId: -1,
                  EmployeeId: employeeId,

                  Date_Str: insertRow.Date_Str,
                  Date: moment(insertRow.Date).format(),
                  WeekNo: insertRow.WeekNo,

                  Seconds: seconds,
                  TotSecondsToHH: insertRow.TotSecondsToHH,
                  TotSecondsTomm: insertRow.TotSecondsTomm,
                  TimeTypeId: insertRow.TimeTypeId,

                  StatusId: this.newStatusId,
                  CategoryId: this.newCategoryId,

                  CarrierId: insertRow.CarrierId,
                  CarrierProjectId: insertRow.CarrierProjectId,//carrierprojectid
                  Project: insertRow.Project,//project

                  ProjectId: insertRow.ProjectId,//projectactivityid
                  Comment: insertRow.Comment,
                };
                timesalaries.push(timesalary);
              }
              else {
                isValidInsertRows = false;
                return;
              }
            });

            if (isValidInsertRows) {
              this.timeService.insertMultipleTimeSalaryTime(timesalaries)
                .subscribe((result: any) => { // success path

                  this.onLoading(false);
                  if (result.IsSuccess) {
                    this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
                    this.dataGrid.instance.cancelEditData();
                    this.dataGrid.instance.endUpdate();
                    this.refresh.emit(false);
                    if (result.Message != null && result.Message.length > 0) {
                      this.amsNotifierService.error(result.Message);
                    }
                  }
                  else {
                    this.amsNotifierService.error(result.ErrorMessage);
                    resolve(false);
                  }

                  resolve(true);
                }, error => { // error path;

                  this.onLoading(false);
                  resolve(false)
                });
            }
            else {
              this.onLoading(false);
            }
            this.rowsToInsert = [];
          }

        }, 1000);

    })
  }

  setLookUps() {
    // project
    this.projectsDataSource = new DataSource({
      key: "ProjectId",
      paginate: true,
      pageSize: 10,
      load: (loadOptions) => {

        if (this.projectIdsDataSource && this.projectIdsDataSource.length > 0 && !this.employeeSelectorVisible) {
          if (loadOptions.searchValue != null) {
            if (loadOptions.searchValue.length >= 3) {
              return this.projectService.getBySearchTextAndProjectIdsVM(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise().then((data: any) => {
                return data.filter((d:any) => !d.IsActivity);
              });
            }
          }
          else {

            return this.projectService.getByIdsVM(this.projectIdsDataSource).toPromise().then((data: any) => {
              return data.filter((d:any) => !d.IsActivity);
            });
          }
        }
        else {
          if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
            return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {
              return data.filter((d:any) => !d.IsActivity);
            });
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise().then((data: any) => {
            return data.filter((d:any) => !d.IsActivity);
          });
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: ""
          }
          return p;
        }
      }
    });

    //customer popup
    this.customerPopupDataSource = new DataSource({
      key: 'CustomerId',
      loadMode: "raw",
      load: (loadOptions) => {
        return this.timeService.getCustomers().toPromise();
      },
      byKey: (key) => {
        return this.timeService.getCustomer(key).toPromise();
      }
    });

    //project popup
    this.projectsPopupDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {

        if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
          return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {
            return data;
          });
        }
        else {
          if (this.selectedCustomerIdPopup > 0) {
            return this.timeService.getProjectsByCustomerId(this.selectedCustomerIdPopup).toPromise().then((data: any) => {
              return data;
            });
          }
          else {
            return [];
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: "",
            CarrierId: -1,
          }
          return p;
        }
      }
    });
    this.getTimeTypes();
    this.getProjectActivities();
  }

  getTimeTypes() {
    this.timeService.getTimeTypes()
      .subscribe((result: any) => { // success path

        this.timetypes = result;
      }, error => { // error path;
      });
  }

  getProjectActivities() {
    this.timeService.getActiveProjectActivites()
      .subscribe((result: any) => { // success path

        this.projectActivities = result;
        this.projectActivitiesByProjectType = result;
      }, error => { // error path;
      });
  }

  getProjectActivitiesByProjectTypeId(projectTypeId: number) {
    this.projectActivitiesByProjectType = [];
    this.projectActivities.forEach(projectActivity => {
      if (projectActivity.ProjectTypeId === projectTypeId) {
        this.projectActivitiesByProjectType.push(projectActivity);
      }
    });
  }

  onEditorPreparing(e) {
    if(e.parentType == "dataRow") {
      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }

      if (!this.allowRowUpdating(e.row.data.StatusId, e.row.data.CategoryId)) {
        e.readOnly = true;
        e.editorOptions.disabled = true;
      }
    }   
  }

  onEditingStart(e: any) {
    this.editRowKey = e.key;

    const shouldTimesBeApprovedByAnotherSupervisor = e.key && this.disableWrongSupervisor && !this.userService.account.IsAdmin && 
      e.key.SupervisorId != null && this.userService.account.IsSupervisor && e.key.SupervisorId != this.userService.account.EmployeeId &&
      e.key.EmployeeId !== this.userService.account.EmployeeId;

    if (shouldTimesBeApprovedByAnotherSupervisor) {
      e.cancel = true;
    }

    this.editingStart.emit(e);
  }

  focusDate(e) {
    e.event.target.select();
  }

  focusProject(e) {
    e.event.target.select();
  }

  focusProjectActivity(e: any, cell: any) {
    e.event.target.select();

    if (!cell || !cell.data) { return; }

    if (cell.data.ProjectActivityUse !== 1 && cell.data.ProjectActivityUse !== 2) {
      this.readonlyProjectActivity = true;
      return;
    }

    this.readonlyProjectActivity = false;
    this.enableProjectActivityColumn = true;

    if (cell.data.ProjectActivityProjectTypeId) {
      this.getProjectActivitiesByProjectTypeId(cell.data.ProjectActivityProjectTypeId);
    }
    else {
      this.projectActivitiesByProjectType = this.projectActivities;
    }
  }

  onCellPrepared(e: any) {
    this.cellPrepared.emit(e);
  }

  //doesnt work on StatusId column for some reason....
  calculateGroupValueStatus(data) {
    return data.StatusId + " - " + data.StatusDescription;
  }

  calculateSummary(options) {
    // Calculating "customSummary1"
    if(options.name == "customSumHours") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.Seconds > 0)
                {
                  options.totalValue += options.value.Seconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
  }

  onDateChanged(e, cell) {
    let dt = moment(e.value);
    var nb = moment(dt).locale('nb');
    let dayname = nb.format('dddd');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    let dateYYYYMMDD = nb.format('YYYY-DD-MM');
    let weekno = nb.format('W');
    let dateValue = {
      Date: e.value,
      Date_YYYYMMDD: dateYYYYMMDD,
      Date_DayName: dayname,
      Date_Str: dateDDMMYYYY,
      WeekNo: nb.isValid() ? weekno : "",
    };
    cell.setValue(dateValue);
  }

  calculateDateCellValue(rowData) {
    let date = rowData.Date;
    let dt = moment(date, "YYYY-MM-DD");
    var nb = moment(dt).locale('nb');
    return dt.format("DD.MM.YYYY");
  }

  customDateCellValue(rowData) {
    return rowData.Date_Str;
  }

  setProjectValue(newData: any, value: any) {
    newData.CarrierProjectId = value && value.ProjectId;
    newData.Project = value && value.ProjectDisplayName;
    newData.CustomerId = value && value.CustomerId;
    newData.CarrierId = value && value.CarrierId;
    newData.ProjectActivityUse = value && value.ProjectActivityUse;
    newData.ProjectActivityProjectTypeId = value && value.ProjectActivityProjectTypeId;
    newData.ProjectId = null;
    newData.Activity = null;
  }

  setFromProjectValue(newData: any, value: any) {
    newData.FromProjectNumber = value && value.ProjectNumber;
  }

  setToProjectValue(newData: any, value: any) {
    newData.ToProjectNumber = value && value.ProjectNumber;
  }

  setEmployeeValue(newData: any, value: any) {
    newData.EmployeeId = value && value.EmployeeId;
    newData.EmployeeNumberAndName = value && value.EmployeeNumberAndName;
  }

  onEmployeeValueChanged(e: any, cell: any) {
    const selectedEmployee = e.component.option("selectedItem");
    if (selectedEmployee) {
      cell.setValue(selectedEmployee);
    }
  }

  onProjectValueChanged(e: any, cell: any) {
    const selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
    }

    cell.component.cellValue(cell.rowIndex, 'Activity', null);
  }

  onFromProjectValueChanged(e: any, cell: any) {
    const selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
    }
  }

  onToProjectValueChanged(e: any, cell: any) {
    const selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
    }
  }

  setProjectActivityValue(newData: any, value: any) {
    newData.ProjectId = value && value.ProjectId;
    newData.Activity = value && value.ProjectNumberAndName;
  }

  onProjectActivityValueChanged(e: any, cell: any) {
    const selectedProjectActivity = e.component.option("selectedItem");
    if (selectedProjectActivity) {
      cell.setValue(selectedProjectActivity);
    }
  }

  onTimeValueChanged(value: any, cell: any) {
    cell.setValue(value);
  }  
  
  showPopupProject(selectedProjectId, selectedCustomerId, cell) {
    this.popupVisible = true;
    this.selectedProjectIdPopup = selectedProjectId ? selectedProjectId : -1;
    if (selectedProjectId <= 0 || !selectedProjectId) {
      this.selectedCustomerIdPopup = -1;
    } else {
      this.timeService.getProjectSearchBoxById(selectedProjectId).toPromise().then((rec) => {
        if (rec !== null) {
          this.selectedProjectItemPopup = rec;
          this.selectedCustomerIdPopup = rec.CustomerId;
        }
      });
    }
  }

  onPopupCustomerChanged(e) {
    if (e.value === -1 || e.value === null) {
      this.selectedCustomerIdPopup = -1;
      this.selectedProjectIdPopup = -1;
    } else {
      this.selectedCustomerIdPopup = e.value;
      this.projectsPopupDataSource.reload().then((recs) => {
        const i1 = recs.findIndex((rec) => rec.ProjectId === this.selectedProjectIdPopup);
        if (i1 !== -1) {
          this.selectedProjectItemPopup = recs[i1];
        } else {
          this.selectedProjectIdPopup = -1;
        }
      });
    }
  }

  onPopupProjectChanged(e: any) {
    if (e.value === -1 || e.value === null) {
      this.selectedProjectIdPopup = -1;
    } else {
      this.selectedProjectIdPopup = e.value;
      this.timeService.getProjectSearchBoxById(e.value).toPromise().then((rec) => {
        if (rec !== null) {
          this.selectedProjectItemPopup = rec;
          this.selectedCustomerIdPopup = rec.CustomerId;
        }
      });
    }
  }

  onClickPopupSelectedProject(e: any) {
    this.popupVisible = false;
    if (this.editRowKey === undefined) { // The key of an added but not yet saved row is undefined
      this.dataGrid.instance.cellValue(0, 'Project', this.selectedProjectItemPopup); 
    } else {
      const editRowIndex = this.dataGrid.instance.getRowIndexByKey(this.editRowKey);
      this.dataGrid.instance.cellValue(editRowIndex, 'Project', this.selectedProjectItemPopup)      
    }
  }

  getSeconds(hours, minutes): number {
    if (!hours) {
      hours = 0;
    }
    if (!minutes) {
      minutes = 0;
    }
    let newHHSeconds = hours * 3600;
    return newHHSeconds + (Number(minutes) * 60);

  }  

  onSavingMultiple(e: any) {
    if (e.changes.length) {
      const copiedRowsWithKeyChanges = []; 
      e.changes.forEach(change => {
        const isKeyChanged = change.data.Date !== undefined || change.data.CarrierId !== undefined || change.data.EmployeeId !== undefined; 
        const isCopiedRow = change.key.StatusId == this.copyTimeStatusId; 

        if (isKeyChanged) {
          copiedRowsWithKeyChanges.push({ 
            StatusId: isCopiedRow ? this.copyTimeStatusId : change.key.StatusId, 
            Date: change.key.Date,
            CarrierId: change.key.CarrierId, 
            EmployeeId: change.key.EmployeeId
          });
        }
        
        if (change.data.Date != undefined) {
          let fromDateStr = this.convertToDateString(this.searchParameters.FromDate);
          let toDateStr = this.convertToDateString(this.searchParameters.ToDate);
          this.isDateChangedOutOfSearchPeriod = !this.isDateBetween(change.data.Date, fromDateStr, toDateStr);         
        }
      });

      e.cancel = true;
      const convertedResult = this.gridToTimeSalaryConverter.convert(e.changes, this.selectedEmployeeId, this.newStatusId, this.newCategoryId, this.showEmployeeColumn);
      if (convertedResult.isValid) {        
        e.promise = this.processBatchRequest(convertedResult, e.component, copiedRowsWithKeyChanges);
      }
    }
  }

  async processBatchRequest(convertedResult: any, component: any, copiedRowsWithKeyChanges: any[]): Promise<void> {
    this.onLoading(true);
    try {
      const result = await this.timeService.saveMultipleTimeSalaryTimes(convertedResult.timeSalariesToAdd, convertedResult.timeSalariesToUpdate, convertedResult.timeSalariesToUpdateWithOriginalPKValues).toPromise();

      if(!result.IsSuccess) {
        this.amsNotifierService.error(result.ErrorMessage);
        return; 
      }

      if (copiedRowsWithKeyChanges.length > 0) {
        const excludeSet = new Set(
          copiedRowsWithKeyChanges.map(item => JSON.stringify({ 
            StatusId: item.StatusId, 
            Date: item.Date,
            CarrierId: item.CarrierId,
            EmployeeId: item.EmployeeId 
          }))
        );
        
        this.dataSource = this.dataSource.filter(item => {
          const itemKey = JSON.stringify({ 
            StatusId: item.StatusId, 
            Date: item.Date,
            CarrierId: item.CarrierId,
            EmployeeId: item.EmployeeId 
          });
          return !excludeSet.has(itemKey);
        });
      }

      if (this.isDateChangedOutOfSearchPeriod) {
        this.isDateChangedOutOfSearchPeriod = false;
      } else {
        this.lastUpdateDate = result.Data;
      }        

      this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
      if (result.Message != null && result.Message.length > 0) {
        this.amsNotifierService.error(result.Message);
      }
      component.cancelEditData();
      this.refresh.emit(false);
    } finally {
      this.onLoading(false);
    }
  }

  onQuickEntriesSaved(timestamp: Date) {
    this.popupQuickEntryVisible = false;
    this.lastUpdateDate = timestamp;
    this.refresh.emit(false);
  }

  onInitNewRow(e) {
    e.data.TimeId = -1;
    if (this.showEmployeeColumn) {
      e.data.EmployeeId = this.selectedEmployeeId;
    }
    this.isNewRow = true;
    e.data.StatusId = this.newStatusId;
  }

  onCopyRow(e, cell) {
    this.cloneData = cell.data;
    this.dataGrid.instance.addRow();
  }

  onToolbarPreparing(e: any) {
    if (this.myApprovalLevelStatuses.length > 0) {
      if(this.projectReadWriteAll || this.employeeHasProjectPermissions) {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            text: this.title,
            visible: this.showTitle,
            cssClass: 'title remove-margin',
          },
          {
            location: 'before',
            widget: 'dxSwitch',
            class: "switch",
            options: {
              value: this.switchShowAll,
              switchedOnText: this.languageService.LNG("Label.Show.Approved"),
              switchedOffText: this.languageService.LNG("Label.Show.All"),
              onValueChanged: this.onValueChangedShowAll.bind(this),
              width: '150px',
              visible: this.showAllSwitchVisible,
            }
          },
          {
            location: 'before',
            widget: 'dxSwitch',
            class: "switch",
            options: {
              value: this.switchOvertimeCheck,
              switchedOnText: this.languageService.LNG("Label.OvertimeCheck.Off"),
              switchedOffText: this.languageService.LNG("Label.OvertimeCheck.On"),
              onValueChanged: this.onValueChangedOvertimeCheck.bind(this),
              width: '150px',
              visible: this.showOvertimeSwitch,
            }
          },
          {
            location: 'before',
            widget: 'dxSwitch',
            class: "switch",
            options: {
              value: this.switchSupervisorCheck,
              switchedOnText: this.languageService.LNG("Label.SupervisorMode.Off"),
              switchedOffText: this.languageService.LNG("Label.SupervisorMode.On"),
              onValueChanged: this.onValueChangedSupervisorCheck.bind(this),
              width: '150px',
              visible: this.showSupervisorApprovalSwitch,
            }
          },
          {
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'clock',
              hint: this.languageService.LNG("Label.QuickEntry"),
              visible: this.portalTypeService.isProjectPortal(this.portalType),
              onClick: () => {
                this.popupQuickEntryVisible = true;
              }
            }
          },
          {
            location: 'after',
            widget: 'dxButton',
            options: {
              template: 'transportBtnTemplate',
              hint: this.languageService.LNG("Label.Transport"),
              visible: this.portalTypeService.isProjectPortal(this.portalType),
              onClick: () => {
                this.titleEditTransport = `${this.languageService.LNG("Label.New")} ${this.languageService.LNG("Label.Transport")}`;
                this.transport = null;
                this.popupEditTransportVisible = true;
              }
            }
          },
          {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'copy',
                hint: this.languageService.LNG("Label.Copy"),
                onClick: this.onCopySelected.bind(this)
            }
          },
          {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'trash',
                hint: this.languageService.LNG("Label.Delete"),
                onClick: this.onDeleteSelected.bind(this)
            }
          });
      }
      else {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            text: this.title,
            visible: this.showTitle,
            cssClass: 'title remove-margin',
          },
          {
            location: 'before',
            widget: 'dxSwitch',
            class: "switch",
            options: {
              value: this.switchShowAll,
              switchedOnText: this.languageService.LNG("Label.Show.Approved"),
              switchedOffText: this.languageService.LNG("Label.Show.All"),
              onValueChanged: this.onValueChangedShowAll.bind(this),
              width: '150px',
              visible: this.showAllSwitchVisible,
            }
          },
          {
            location: 'before',
            widget: 'dxSwitch',
            class: "switch",
            options: {
              value: this.switchOvertimeCheck,
              switchedOnText: this.languageService.LNG("Label.OvertimeCheck.On"),
              switchedOffText: this.languageService.LNG("Label.OvertimeCheck.Off"),
              onValueChanged: this.onValueChangedOvertimeCheck.bind(this),
              width: '150px',
              visible: this.showOvertimeSwitch,
            }
          });
      }
    }
  }

  onSaveEditData() {
    this.dataGrid.instance.saveEditData();
  }
  
  async onCopySelected() {
    let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

    let timeIds: number[] = []; 
    if (selectedRowsData.length > 0) {
      selectedRowsData.forEach(rowData => {
        timeIds.push(rowData.TimeId); 
      }); 
      
      if (timeIds.length > 0) 
      {
        this.onLoading(true);
        const result = await this.timeService.copyAndSaveTimeSalaries(timeIds).toPromise();
        this.onLoading(false);

        if (!result.IsSuccess) {
          this.amsNotifierService.error(result.ErrorMessage);
          return;
        }

        this.lastUpdateDate = result.Data;     
        this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
        
        this.refresh.emit(false); 
      }
    }
  }

  onDeleteSelected() {
    let myDialog = custom({
      title: this.languageService.LNG("Label.Delete"),
      messageHtml: this.languageService.LNG("Label.Do.You.Want.To.Delete.The.Selected.Rows"),
      buttons: [{
          text: this.languageService.LNG("Label.Yes"),
          onClick: (e) => {
              return true;
          }
      }, {
        text: this.languageService.LNG("Label.No"),
        onClick: (e) => {
            return false;
        }
    },
      ]
    });

    myDialog.show().then((confirmed: boolean) => {
      if (!confirmed) { return; }

      const selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

      if (selectedRowsData.length === 0)
      {
        this.amsNotifierService.info(this.languageService.LNG("Label.Please.Select.Rows.To.Delete"));
        return;
      }

      const timeFilters = [];

      for (let i = 0; i < selectedRowsData.length; i++) {
        const timeSalary = selectedRowsData[i];

        const isAllowedStatus = timeSalary.StatusId === this.newStatusId || this.myApprovalLevelStatuses.includes(timeSalary.StatusId) || 
          timeSalary.StatusId === this.copyTimeStatusId; 
        const isAllowedCategory = timeSalary.CategoryId === this.newCategoryId || timeSalary.CategoryId === 8;  
        const isSignedInUsersTimeSalary = timeSalary.EmployeeId === this.userService.account.EmployeeId && timeSalary.StatusId === 3 && 
          timeSalary.CategoryId === 6;

        if ((isAllowedStatus && isAllowedCategory) || isSignedInUsersTimeSalary) {
          timeFilters.push({ CarrierId: timeSalary.CarrierId, ProjectId: timeSalary.ProjectId, Date: timeSalary.Date, EmployeeId: timeSalary.EmployeeId, CategoryId: timeSalary.CategoryId, StatusId: timeSalary.StatusId });
        }
      }

      if (timeFilters.length === 0) {
        this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Delete"));
        return;
      }
      
      this.onLoading(true);

      if (timeFilters.length > 100) {
        const arrayRequests = [];
        let startIndex = 0, endIndex = 100;

        while (endIndex <= timeFilters.length) {
          const timeFiltersSliced = timeFilters.slice(startIndex, endIndex);
          if (timeFiltersSliced.length === 0) { break; }

          const requestDelete = this.timeService.deleteTimeSalaries(timeFiltersSliced);
          arrayRequests.push(requestDelete);
          startIndex = endIndex;
          endIndex = endIndex + 100 > timeFilters.length ? timeFilters.length : endIndex + 100;
          if (startIndex > timeFilters.length) { break; }
        }

        forkJoin(arrayRequests).toPromise().then(results => {
          if (results.length > 0) {
            for (let i = 0; i < results.length; i++) {
              const result: any = results[i];

              if (!result.IsSuccess) {
                this.amsNotifierService.error(result.ErrorMessage);
              }
            }
          }
          this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
          this.onLoading(false);
          this.dataGrid.selectedRowKeys = [];
          this.dataSource = this.dataSource.filter((x: any) =>
            !timeFilters.find(tf => tf.CarrierId === x.CarrierId &&
              tf.ProjectId === x.ProjectId &&
              tf.Date === x.Date &&
              tf.EmployeeId === x.EmployeeId &&
              tf.CategoryId === x.CategoryId && 
              tf.StatusId === x.StatusId));
        });
      }
      else {
        this.timeService.deleteTimeSalaries(timeFilters).subscribe((result: any) => {
          this.onLoading(false);

          if (!result.IsSuccess) {
            this.amsNotifierService.error(result.ErrorMessage);
            return;
          }

          this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
          this.dataGrid.selectedRowKeys = [];
          this.dataSource = this.dataSource.filter((x: any) =>
            !timeFilters.find(tf => tf.CarrierId === x.CarrierId &&
              tf.ProjectId === x.ProjectId &&
              tf.Date === x.Date &&
              tf.EmployeeId === x.EmployeeId &&
              tf.CategoryId === x.CategoryId && 
              tf.StatusId === x.StatusId));
        }, _ => {
          this.onLoading(false);
        });
      }
    });
  }

  getSelectedRows() {
    return this.dataGrid.instance.getSelectedRowKeys();
  }

  getSelectedRowsData() {
    return this.dataGrid.instance.getSelectedRowsData();
  }

  onSelectionChanged(e) {
    if (e.currentSelectedRowKeys.length === 0) {
      this.rowClicked.emit(null);
      return;
    }

    if (e.currentSelectedRowKeys[0]) {
      if (e.currentSelectedRowKeys[0].IsTransport) {
        let carrierId = e.currentSelectedRowKeys[0].CarrierId;
        this.selectedCarrierIdTransportRow.emit(carrierId);
      }
      this.rowClicked.emit(e.currentSelectedRowKeys[0]);
    }
  }

  //prevent all rows from being confirmed when none are selected if the page has multiple grids. Then some of the other grids may have selected rows
  onConfirm(preventConfirmAll: boolean = false): Promise<boolean> {
    this.onLoading(true);
    return new Promise(resolve => {
      let timeIds: number[] = [];
      let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
      if (selectedRowsData.length == 0 && !preventConfirmAll) {
        this.dataSource.forEach(time => {
          selectedRowsData.push(time);
        });
      }

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
          //Eirik 11.06.21 v2.0.32.9 task 1200 - if user is supervisor and the time post has another SupervisorId, then make it unapprovable for user
          if (!this.userService.account.IsAdmin && selectedRowsData[i].SupervisorId != null && this.userService.account.IsSupervisor &&
            selectedRowsData[i].SupervisorId != this.userService.account.EmployeeId  &&
            (this.userService.account.IsAdmin || this.userService.account.IsSupervisor)) {
              continue;
          }
          if (selectedRowsData[i].StatusId === 2 && selectedRowsData[i].CategoryId === 1) {
            timeIds.push(selectedRowsData[i].TimeId);
          }
        }

        if (timeIds.length > 0) {
          if (timeIds.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= timeIds.length) {
              let timeIdsSliced = timeIds.slice(startIndex, endIndex);
              if (timeIdsSliced.length === 0) {
                break;
              }

              let requestConfirm = this.timeService.confirmTimeSalaryTimeIds(timeIdsSliced);
              arrayRequests.push(requestConfirm);
              startIndex = endIndex;
              endIndex = endIndex + 100 > timeIds.length ? timeIds.length : endIndex + 100;
              if (startIndex > timeIds.length) {
                break;
              }
            }
            forkJoin(arrayRequests).toPromise().then(result => {

              if (result.length > 0) {
                for (let i = 0; i < result.length; i++) {

                }
              }
              this.amsNotifierService.success(this.languageService.LNG("Label.Confirmed"));
              this.onLoading(false);
              this.dataGrid.selectedRowKeys = [];
              resolve(true);
            });
          }
          else {
            this.timeService.confirmTimeSalaryTimeIds(timeIds).subscribe((result: any) => { // success path
              this.lastUpdateDate = result.Data;

              this.amsNotifierService.success(this.languageService.LNG("Label.Confirmed"));
              this.onLoading(false);
              this.dataGrid.selectedRowKeys = [];
              resolve(true);
            }, error => { // error path;
              this.onLoading(false);
              resolve(false);
            });
          }
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Confirm"));
          this.onLoading(false);
          resolve(false);
        }
      }
      else {
          resolve(false);
      }
    })
  }

  onApprove(): Promise<boolean> {
    return new Promise(resolve => {
      const selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

      if (selectedRowsData.length === 0) {
        resolve(false);
        return;
      }

      const timeFilters = [];
      let errorMessageNoRows = this.languageService.LNG("Label.No.Time.Posts.To.Approve");

      this.onLoading(true);

      for (let i = 0; i < selectedRowsData.length; i++) {
        const timeSalary = selectedRowsData[i];

        //Eirik 11.06.21 v2.0.32.9 task 1200 - if user is supervisor and the time post has another SupervisorId, then make it unapprovable for user
        if (!this.userService.account.IsAdmin && timeSalary.SupervisorId != null && this.userService.account.IsSupervisor &&
          timeSalary.SupervisorId != this.userService.account.EmployeeId  &&
          (this.userService.account.IsAdmin || this.userService.account.IsSupervisor)) {
            errorMessageNoRows = this.languageService.LNG("Label.Cannot.Approve.Time.Posts.Registered.On.Another.Supervisor");
            continue;
        }

        timeFilters.push({ CarrierId: timeSalary.CarrierId, ProjectId: timeSalary.ProjectId, Date: timeSalary.Date, EmployeeId: timeSalary.EmployeeId, CategoryId: timeSalary.CategoryId, StatusId: timeSalary.StatusId });
      }

      if (timeFilters.length > 0) {
        this.isApproving = true;

        if (timeFilters.length > 100) {
          const arrayRequests = [];
          let startIndex = 0;
          let endIndex = 100;

          while (endIndex <= timeFilters.length) {
            const timeFiltersSliced = timeFilters.slice(startIndex, endIndex);
            if (timeFiltersSliced.length === 0) { break; }

            const requestConfirm = this.timeService.approveTimeSalaries(timeFiltersSliced, this.approvalFunction);
            arrayRequests.push(requestConfirm);
            startIndex = endIndex;
            endIndex = endIndex + 100 > timeFilters.length ? timeFilters.length : endIndex + 100;
            if (startIndex > timeFilters.length) { break; }
          }
          forkJoin(arrayRequests).subscribe((results: any) => {
            this.onLoading(false);
            let bAllOk = true;
            for(let result of results){
              if (result.Message !== null && result.Message.length > 0) {
                this.isApproving = false;
                this.amsNotifierService.error(result.Message);
                bAllOk = false;
              } else {
                this.lastUpdateDate = result.Data;
              }
            }
            if (bAllOk) {
              this.amsNotifierService.success(this.languageService.LNG("Label.Is.Approved"));
              this.dataGrid.selectedRowKeys = [];
            }
            resolve(true);
          });
        }
        else {
          this.timeService.approveTimeSalaries(timeFilters, this.approvalFunction).subscribe((result: any) => {
            this.onLoading(false);            

            if (result.IsSuccess) {
              this.lastUpdateDate = result.Data;

              if (result.Message !== null && result.Message.length > 0) {
                this.amsNotifierService.error(result.Message);
              }
              this.dataGrid.selectedRowKeys = [];
              this.amsNotifierService.success(this.languageService.LNG("Label.Is.Approved"));
              resolve(true);
            }
            else {
              this.isApproving = false;
              this.amsNotifierService.error(result.ErrorMessage);
              resolve(false);
            }
          }, error => { // error path;
            this.isApproving = false;
            this.onLoading(false);
            resolve(false);
          });
        }
      }
      else {
        this.isApproving = false;
        this.amsNotifierService.info(errorMessageNoRows);
        this.onLoading(false);
        resolve(false);
      }
    })
  }

  onReset(statusId: number): Promise<boolean> {
    return new Promise(resolve => {
      const selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

      if (selectedRowsData.length === 0) {
        resolve(true);
        return;
      }

      this.onLoading(true);
      const timeFilters = [];

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
          if (!this.userService.account.IsAdmin && selectedRowsData[i].SupervisorId != null && this.userService.account.IsSupervisor &&
            selectedRowsData[i].SupervisorId != this.userService.account.EmployeeId  &&
            (this.userService.account.IsAdmin || this.userService.account.IsSupervisor)) {
              continue;
          }

          timeFilters.push(selectedRowsData[i]);
        }

        if (timeFilters.length > 0) {
          this.isResetting = true;

          if (timeFilters.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= timeFilters.length) {
              let timeFiltersSliced = timeFilters.slice(startIndex, endIndex);
              if (timeFiltersSliced.length === 0) {
                break;
              }

              let requestConfirm = this.timeService.resetTimeSalaryTimeIds(timeFiltersSliced, this.approvalFunction, statusId);
              arrayRequests.push(requestConfirm);
              startIndex = endIndex;
              endIndex = endIndex + 100 > timeFilters.length ? timeFilters.length : endIndex + 100;
              if (startIndex > timeFilters.length) {
                break;
              }
            }
            forkJoin(arrayRequests).subscribe((results: any) => {
              this.onLoading(false);
              let bAllOk = true;
              for(let result of results) {
                if (result.Message !== null && result.Message.length > 0) {
                  this.isResetting = false;
                  this.amsNotifierService.error(result.Message);
                  bAllOk = false;
                } else {
                  this.lastUpdateDate = result.Data;
                }
              }
              if (bAllOk) {
                this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                this.dataGrid.selectedRowKeys = [];
              }
              resolve(true);
            });
          }
          else {
            this.timeService.resetTimeSalaryTimeIds(timeFilters, this.approvalFunction, statusId).subscribe((result: any) => { // success path
              this.onLoading(false);

              if (result.IsSuccess) {
                this.lastUpdateDate = result.Data;

                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                else {
                  this.dataGrid.selectedRowKeys = [];
                  this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                }
                resolve(true);
              }
              else {
                this.isResetting = false;
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(false);
              }
            }, error => {
              this.onLoading(false);
              resolve(false);
            });
          }
        }
        else {
          this.isResetting = false;
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Posts.To.Reset"));
          this.onLoading(false);
          resolve(false);
        }
      }
      else {
        resolve(false);
      }
    });
  }

  onReadySalary(): Promise<boolean> {
    this.onLoading(true);
    return new Promise(resolve => {

      let timeIds: number[] = [];
      let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
          if (selectedRowsData[i].StatusId === 4 && selectedRowsData[i].CategoryId === 6) {
            timeIds.push(selectedRowsData[i].TimeId);
          }
        }
        if (timeIds.length > 0) {
          this.timeService.readySalaryTimeSalaryTimeIds(timeIds).subscribe((result: any) => { // success path

            this.onLoading(false);
            this.dataGrid.selectedRowKeys = [];
            resolve(true);
          }, error => {
            this.onLoading(false);
            resolve(false);
          });
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Approve"));

          this.onLoading(false);
          resolve(false);
        }
      }
      else {//approve all
        this.timeService.readySalaryTimeSalaryEmployeeIds(this.searchParameters.EmployeeIds, this.searchParameters.FromDate, this.searchParameters.ToDate, this.searchParameters.StatusIds, this.searchParameters.DepartmentIds, this.searchParameters.IsSupervisor, this.searchParameters.SelectedSupervisorId).subscribe((result: any) => { // success path

          this.onLoading(false);
          this.dataGrid.selectedRowKeys = [];
          resolve(true);
        }, error => {
          this.onLoading(false);
          resolve(false);
        });

      }
    })
  }

  async loadRoleApprovalLevels() {
    const result = await this.roleService.getMyApprovalLevelStatusesFromApprovalFunction(this.approvalFunction).toPromise();
    this.myApprovalLevelStatuses = result;
    this.approvalLevelStatuses.emit(result);
  }

  async onOpenTransport(e: any, cell: any) {
    this.onLoading(true);
    const result = await this.timeService.getTransportFromTimeId(cell.data.TimeId).toPromise();
    this.onLoading(false);

    this.titleEditTransport = this.languageService.LNG("Label.Edit") + " " + this.languageService.LNG("Label.Transport");
    this.transport = result.Data;
    this.popupEditTransportVisible = true;
  }

  getFirstLetterOfStatus(data: any) {
    const cellStatus = this.statuses.find(s => s.StatusId === data.StatusId);
    if(cellStatus) {
      const statusCode = cellStatus.LanguageTagLabel !== "" ? this.languageService.LNG(cellStatus.LanguageTagLabel) : cellStatus.Code;
      return statusCode.charAt(0); 
    }
    else return 'U'; 
  }

  onRefresh(e) {
    this.dataGrid.instance.refresh();
    this.dataGrid.instance.repaint();
    this.refresh.emit(false);
  }

  private async loadStatuses() {
    const result = await this.roleService.getStatuses().toPromise();
    this.statuses = result;
    this.allStatuses.emit(result);

    result.forEach(status => {
      this.headerFilterData.push( {
        text: status.LanguageTagLabel !== "" ? this.languageService.LNG(status.LanguageTagLabel) : status.Code,
        value: ["StatusId", "=", status.StatusId]
      });
    });
  }

  @Input()
  set gridRecords(recs: any[]) {
    this.dataSource = recs;
  }

  @Input()
  set projectIds(ids: any[]) {
    this.projectIdsDataSource = ids;
    if (this.projectsDataSource) {
      this.projectsDataSource.reload();//Eirik 25.09.20 - reload to search with new projects
    }
  }

  @Input()
  set setEditMode(mode: string) {
    this.editMode = mode;
  }

  setAllowEditUnconfirmed(allow: boolean) {
    this.allowEditUnconfirmed = allow;
  }

  setAllowEditConfirmed(allow: boolean) {
    this.allowEditConfirmed = allow;
  }

  onLoading(loading: boolean) {
    this.loading.emit(loading);
  }

  onValueChangedShowAll(event : any) {
    this.switchShowAll = event.value;
    this.showAllSwitchClicked.emit();
  }

  onValueChangedOvertimeCheck(event : any) {
    if(this.showOvertimeSwitch) {
      localStorage.setItem(this.overtimeCheckKey, event.value);
      this.overtimeCheckActive.emit(event.value);
    }
  }

  onValueChangedSupervisorCheck(event: any) {
    if (this.showSupervisorApprovalSwitch) {
      localStorage.setItem(this.supervisorCheckKey, event.value);
      this.supervisorApprovalSwitchActive.emit(event.value);
    }
  }

  allowAddingAndUpdate() {
    return (this._projectReadWriteAll || this._employeeHasProjectPermissions) && this.myApprovalLevelStatuses.length > 0;    
  }

  allowRowUpdating(statusId: any, categoryId: any) {
    return categoryId != 1 && categoryId != 7 && (this._projectReadWriteAll || this._employeeHasProjectPermissions) && 
      (this.myApprovalLevelStatuses.includes(statusId) || this.isNewRow || statusId == this.copyTimeStatusId);
  }

  convertToDateString(dateStr: string) {
    let dateArray = dateStr.split('.');
    dateStr = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0] + 'T00:00:00';
    return dateStr;
  }

  isDateBetween(dateStr: string, startStr: string, endStr: string): boolean {
    const date = new Date(dateStr);
    const startDate = new Date(startStr);
    const endDate = new Date(endStr);

    return date >= startDate && date <= endDate;
  }
}
